module.exports = __webpack_public_path__ + "static/media/comex.67c64f5f.svg";